/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Components_Credentials_Modal_Delete_TitleInputs */

const es_components_credentials_modal_delete_title = /** @type {(inputs: Components_Credentials_Modal_Delete_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Eliminar credencial`)
};

const en_components_credentials_modal_delete_title = /** @type {(inputs: Components_Credentials_Modal_Delete_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Delete Credential`)
};

/**
* | output |
* | --- |
* | "Delete Credential" |
*
* @param {Components_Credentials_Modal_Delete_TitleInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const components_credentials_modal_delete_title = /** @type {((inputs?: Components_Credentials_Modal_Delete_TitleInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Components_Credentials_Modal_Delete_TitleInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_components_credentials_modal_delete_title(inputs)
	return en_components_credentials_modal_delete_title(inputs)
});
export { components_credentials_modal_delete_title as "components.credentials.modal.delete.title" }